import React, { useEffect } from 'react';
import Register from '../../components/Registration/Register/Register';
import HeaderAuth from '../../components/HeaderAuth/HeaderAuth';

const RegisterPage = () => {
  useEffect(() => {
    document.body.removeAttribute('class');
    document.title = 'Реєстрація | New Brain';
  }, []);

  return (
    <div>
      <HeaderAuth />
      <section className='container container--login'>
        <Register />
      </section>
    </div>
  );
};

export default RegisterPage;